var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 66,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M43.72 48.82a75 75 0 0 0 16.5-6.4 28.46 28.46 0 0 1-9.761-17.935l-.316-2.354a19.04 19.04 0 0 0-7.281-12.58 18.9 18.9 0 0 0-14.005-3.738 18.9 18.9 0 0 0-12.525 7.296 19.04 19.04 0 0 0-3.708 14.055l.316 2.354a28.46 28.46 0 0 1-4.693 19.874 75 75 0 0 0 17.607 1.824m17.865-2.397a76.2 76.2 0 0 1-17.865 2.397m17.865-2.397a9.54 9.54 0 0 1-.225 8.606 9.5 9.5 0 0 1-2.946 3.29 9.435 9.435 0 0 1-12.208-1.257 9.52 9.52 0 0 1-2.486-8.242M3 23.662A28.45 28.45 0 0 1 7.884 8.627M49.83 3a28.45 28.45 0 0 1 8.673 13.216"
  })));
};
export default SvgBell;